import { render } from "./B2bPagePendingsTask.vue?vue&type=template&id=4d35839c&scoped=true&lang=pug"
import script from "./B2bPagePendingsTask.vue?vue&type=script&lang=js"
export * from "./B2bPagePendingsTask.vue?vue&type=script&lang=js"

import "./B2bPagePendingsTask.vue?vue&type=style&index=0&id=4d35839c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4d35839c"]])

export default __exports__